import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/teachersZoomConvertido.webp'


const _withScopeId = n => (_pushScopeId("data-v-00687bb9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "freeClass" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "freeClass__image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "image__image",
    src: _imports_0,
    alt: "Picture of teachers and students on zoom"
  })
], -1))
const _hoisted_3 = { class: "freeClass_information" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "information__title" }, [
  /*#__PURE__*/_createTextVNode(" PROBÁ UNA CLASE"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("GRATUITA ")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  id: "pTag",
  class: "information__text"
}, [
  /*#__PURE__*/_createTextVNode(" antes de inscribirte, asistí una clase grupal sin costo"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" para conocer nuestra metodología y dinámica! ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("article", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("button", {
        id: "testClass",
        class: "information__button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.startFreeClass && _ctx.startFreeClass(...args)))
      }, " reservá tu clase ")
    ])
  ]))
}